"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _marketingEvents = require("@/api/marketingFunction/marketingEvents");
var _wedding = require("@/api/wedding");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Wedding',
  data: function data() {
    return {
      options: [{
        value: '0',
        label: '未开始'
      }, {
        value: '1',
        label: '进行中'
      }, {
        value: '2',
        label: '已结束'
      }],
      queryData: {
        activityName: '',
        status: '',
        page: 1,
        size: 10
      },
      pagination: {
        total: 0 // 条数
      },
      tableData: [],
      colorObj: {
        '0': '#F8AE13',
        '1': '#52C41A',
        '2': '#BBBBBB'
      },
      textObj: {
        '0': '未开始',
        '1': '进行中',
        '2': '已结束'
      }
    };
  },
  created: function created() {
    this.activityList();
  },
  methods: {
    onPlatform: function onPlatform(value) {
      this.queryData.unionCode = value.id;
      this.onInquire();
    },
    // 查询
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.activityList();
    },
    // 初始化
    onInit: function onInit() {
      this.queryData = {
        activityName: '',
        status: null,
        page: 1,
        size: 10
      };
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.activityList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.activityList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.activityList();
    },
    // 选择
    onSelectEvents: function onSelectEvents(value) {
      var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
        Display_type: 11,
        // 区分类型
        Display_name: '礼金补贴活动' // 名字
      });
      this.$emit('SelectEvents', data);
      this.onInit();
    },
    // 列表
    activityList: function () {
      var _activityList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.tableLoading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _wedding.get_act)(params);
            case 1:
              res = _context.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function activityList() {
        return _activityList.apply(this, arguments);
      }
      return activityList;
    }()
  }
};